import { Box, Stack, Theme, useMediaQuery } from "@mui/material";

import ScrollTopProvider from "components/providers/ScrollTopProvider";
import { WithChildren } from "utils/types";

import SidebarDrawer from "./SidebarDrawer";
import MobileSidebar from "./SidebarDrawer/MobileSidebar";

const DefaultLayout = ({
  showBreadcrumbs: _showBreadcrumbs,
  children,
}: WithChildren<{ showBreadcrumbs?: boolean }>) => {
  const isDesktop = useMediaQuery<Theme>((t) => t.breakpoints.up("lg"));

  return (
    <ScrollTopProvider>
      <Box
        display="grid"
        gridTemplateAreas={isDesktop ? "'sidebar content'" : "'content'"}
        gridTemplateColumns={isDesktop ? "min-content 1fr" : "1fr"}
        height="100dvh"
        width="100dvw"
        overflow="hidden"
      >
        {isDesktop && (
          <Box gridArea="sidebar">
            <SidebarDrawer />
          </Box>
        )}

        <Box
          gridArea="content"
          minHeight="100%"
          height="100%"
          display="flex"
          flexDirection="column"
          flex={1}
          overflow="auto"
          className="content"
        >
          <Stack
            component="main"
            height="100%"
            flex={1}
            overflow="scroll"
            className="scrollbar-hidden"
            sx={{
              position: "relative",
              flexGrow: 1,
              p: { xs: 1.5, sm: 2, md: 3 },
              py: { xs: 1.5, sm: 2 },
              bgcolor: "background.default",
            }}
          >
            {!isDesktop && <MobileSidebar />}
            {children}
          </Stack>
        </Box>
      </Box>
    </ScrollTopProvider>
  );
};

export default DefaultLayout;
